import { Toaster } from 'react-hot-toast';
import { ReactNode } from 'react';

export default function RootLayout({ children }: { children: ReactNode }) {
    return (
        <>
            <Toaster />
            {children}
        </>
    );
}
